module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-up-circle-16d7f825325afb1f96466a6e5b8cf049.svg";